<template>
    <toolbar-option>
        <template slot="primary">
            <calendar-facet-dot-color
                :value="dot.class"
                @input="onColorInput"
            />
        </template>
        <template slot="secondary">
            <div class="f-flex f-mt-0.25 f-ml-1">
                <toggle
                    :value="dot.show"
                    :messages="messages"
                    @input="onInput"
                />
            </div>
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

const CUSTOM_ATTR_NAME = 'calendar-facet-dot';

export default {
    name: 'calendar-facet-dot',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Show a Dot under date',
            message: '',
            value: '',
            checked: false,
            messages: {
                checked: 'Yes',
                unchecked: 'No',
            },
            dot: {
                class: '',
                show: false,
            },
        };
    },

    methods: {
        onInput(isChecked) {
            if (isChecked) {
                this.dot.show = true;
                this.selectedElements[0].setElementData(CUSTOM_ATTR_NAME, this.dot);
                this.selectedElements[0].showDots = true;
            } else {
                this.dot.show = false;
                this.selectedElements[0].setElementData(CUSTOM_ATTR_NAME, this.dot);
                this.selectedElements[0].showDots = false;
            }

            this.onOptionChange(isChecked);
        },

        onColorInput(cssClass) {
            this.dot.class = cssClass;
            this.selectedElements[0].setElementData(CUSTOM_ATTR_NAME, this.dot);
            this.selectedElements[0].dotClass = cssClass;
        },

        onSelectedElement() {
            this.dot = this.selectedElements[0].hasElementData(CUSTOM_ATTR_NAME) ? this.selectedElements[0].getElementData(CUSTOM_ATTR_NAME) : this.dot;
        },
    },
};
</script>
